export default __webpack_public_path__ + "static/media/aafat.8a8ae552.jpg";